import { render } from "./Agreement2View.vue?vue&type=template&id=08628ae4"
import script from "./Agreement2View.vue?vue&type=script&lang=js"
export * from "./Agreement2View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__